import EditableInput from '@/components/editable-input'

import { cn } from '@/utils'
import { useAtom } from 'jotai'

import { RundownPermission } from '~shared/types'

import { rundownAtom } from '@/store/rundown.store'

import { updateRundown } from '../../../firestore'
import { useRundownAccess } from '../../permissions/lib/use-rundown-access'

export function RundownNavbarName() {
  const [rundown, setRundown] = useAtom(rundownAtom)

  const { hasPermission } = useRundownAccess()
  const canEdit = hasPermission(RundownPermission.EDIT)

  const handleRundownRename = async (newName: string) => {
    if (!rundown) return

    const { data } = await updateRundown(rundown.id, { name: newName })
    setRundown(data)
  }

  return (
    <EditableInput
      className={cn(
        'text-sm whitespace-pre truncate min-w-20 max-w-75',
        canEdit && 'h-7 px-2 hover:bg-gray-900 focus:bg-gray-900',
      )}
      value={rundown?.name}
      onChange={handleRundownRename}
      disabled={!canEdit}
      required
    />
  )
}
